import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input } from '../../../Elements';
import styles from './TermsBuilder.scss';

const Cancellation = ({ contractVariables, textFieldChange }) =>
  <div>
    <h3>
      How many days in advance must a client notify you to cancel the event
      booking?
    </h3>
    <Input
      className={styles.inlineField}
      name='cancellationBeforeDays'
      type='number'
      inline
      required
      validationError='Required'
      value={contractVariables.cancellationBeforeDays}
      onChange={textFieldChange}
    />
    <div className={styles.inlineFieldLabel}>days</div>
    <h3>
      If the client informs you before the above timeframe, what percent of the
      total fees does the client still owe?
    </h3>
    <Input
      className={styles.inlineField}
      name='cancellationPenalty'
      type='number'
      inline
      required
      validationError='Required'
      value={contractVariables.cancellationPenalty}
      onChange={textFieldChange}
    />
    <div className={styles.inlineFieldLabel}>percent</div>
    <h3>
      If the client informs you after the above timeframe, what percent of the
      total fees does the client still owe?
    </h3>
    <Input
      className={styles.inlineField}
      name='lateCancellationPenalty'
      type='number'
      inline
      required
      validationError='Required'
      value={contractVariables.lateCancellationPenalty}
      onChange={textFieldChange}
    />
    <div className={styles.inlineFieldLabel}>percent</div>
  </div>;

Cancellation.propTypes = {
  contractVariables: PropTypes.object.isRequired,
  textFieldChange: PropTypes.func.isRequired
};

export default Cancellation;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/Cancellation.js